<template>
<div>我是冬天</div>
</template>

<script>
export default {
  name: "Winter"
}
</script>

<style scoped>
div{
  width: 100px;
  height: 100px;
  margin: 0 auto;
  background: gray;
}
</style>